module.exports = __webpack_public_path__ + "img/dettol-spray.bedd8a7c.jpg";